import { createFileRoute } from "@tanstack/react-router";
import AuthShell from "@/ui/components/auth/shell";
import VerifyEmail from "@/ui/components/auth/verify-email";

/**
 * Sits outside the `_auth` layout on purpose: it renders its own shell and
 * must stay reachable by an account that already has a session, which the
 * `_auth` guard would otherwise redirect away.
 */
export const Route = createFileRoute("/verify-email")({
  component: () => (
    <AuthShell>
      <VerifyEmail />
    </AuthShell>
  ),
});
